import { jsx as o } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { useMemo as n } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import { TX_DATA_CONTAINER as i, TX_DATA_HEAD_CONTAINER as a } from "../constants.js";
import m from "../../../../../core/Context/useCoreContext.js";
import t from "../../../../internal/Typography/Typography.js";
import { TypographyElement as p, TypographyVariant as e } from "../../../../internal/Typography/types.js";
const A = () => {
  const { i18n: r } = m();
  return n(
    () => /* @__PURE__ */ o("div", { className: `${i} ${a}`, children: [
      /* @__PURE__ */ o(t, { el: p.DIV, variant: e.SUBTITLE, stronger: !0, children: r.get("refundAction") }),
      /* @__PURE__ */ o(t, { variant: e.BODY, children: r.get("refundNotice") })
    ] }),
    [r]
  );
};
export {
  A as default
};
